import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import NewDashboard from "./pages/NewDashboard";
import Students from "./pages/Students";
import StudentDetail from "./pages/StudentDetail";
import AddSchools from "./pages/AddSchools";
import SupportPlans from "./pages/SupportPlans";
import Analysis from "./pages/Analysis";
import AddStudent from "./pages/AddStudent";
import SessionTimeoutBox from "./SessionTimeoutBox";
import "./App.css";
import MFA from "./pages/MFA";
import MFASMS from "./pages/MFASMS";
import AdminTools from "./pages/AdminTools";
import ChangePassword from "./pages/ChangePassword";
import VerifyEmail from "./pages/VerifyEmail";
import VerifyEmailSuccess from "./pages/VerifyEmailSuccess";
import CalendarPage from "./pages/Calendar";
import Footer from "./components/Layout/Footer";
import Navbar from "./components/Layout/Navbar";

function AppShell() {
  const location = useLocation();
  const hideNavbar = [
    "/login",
    "/signup",
    "/change-password",
    "/mfa",
    "/mfa-sms",
    "/forgot-password",
    "/reset-password",
    "/verify-email",
    "/verify-email-success",
  ].includes(location.pathname);
  return (
    <>
      {!hideNavbar && <Navbar />}
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/mfa" element={<MFA />} />
          <Route path="/mfa-sms" element={<MFASMS />} />
          <Route path="/dashboard" element={<NewDashboard />} />
          <Route path="/students" element={<Students />} />
          <Route path="/students/:studentId" element={<StudentDetail />} />
          <Route path="/add-schools" element={<AddSchools />} />
          <Route path="/add-student" element={<AddStudent />} />
          <Route path="/support-plans" element={<SupportPlans />} />
          <Route path="/analysis" element={<Analysis />} />
          <Route path="/admin-tools" element={<AdminTools />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route
            path="/verify-email-success"
            element={<VerifyEmailSuccess />}
          />
          <Route path="/calendar" element={<CalendarPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="app-shell">
      <Router>
        <SessionTimeoutBox minWarning={5} />
        <AppShell />
      </Router>
    </div>
  );
}

export default App;
